<template>
  <div class="switch__container">
    <input
      id="switch-shadow"
      class="switch switch--shadow"
      type="checkbox"
      :value="toggle"
      @input="$emit('updateToggle' ,$event.target.checked)"
      :checked="toggle">
    <label for="switch-shadow"></label>
  </div>
</template>

<script>
export default {
  name: "AppToggle",

  props: {
    toggle: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.switch__container {
  width: 40px;
}

.switch {
  visibility: hidden;
  position: absolute;
  margin-left: -9999px;
}

.switch + label {
  display: block;
  position: relative;
  cursor: pointer;
  outline: none;
  user-select: none;
}

.switch--shadow + label {
  width: 41px;
  height: 21px;
  background-color: #dddddd;
  border-radius: 20px;
}
.switch--shadow + label:before,
.switch--shadow + label:after {
  display: block;
  position: absolute;
  top: 1px;
  left: 1px;
  bottom: 1px;
  content: "";
}
.switch--shadow + label:before {
  right: 1px;
  background-color: #f1f1f1;
  border-radius: 20px;
  transition: background 0.4s;
}
.switch--shadow + label:after {
  width: 19px;
  background-color: #fff;
  border-radius: 100%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  transition: all 0.4s;
}
.switch--shadow:checked + label:before {
  background-color: rgba(#42b983, 0.5);
}
.switch--shadow:checked + label:after {
  transform: translateX(20px);
}
</style>
